var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "200px" },
              attrs: {
                filterable: "",
                clearable: "",
                placeholder: "请选择营销型号"
              },
              model: {
                value: _vm.searchData.code,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "code", $$v)
                },
                expression: "searchData.code"
              }
            },
            _vm._l(_vm.droplist2, function(item, index) {
              return _c("el-option", {
                key: index,
                attrs: {
                  label: item.name + " (" + item.code + ")",
                  value: item.code
                }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "200px" },
              attrs: {
                filterable: "",
                clearable: "",
                placeholder: "请选择品牌名称"
              },
              model: {
                value: _vm.searchData.brandId,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "brandId", $$v)
                },
                expression: "searchData.brandId"
              }
            },
            _vm._l(_vm.droplist, function(item, index) {
              return _c("el-option", {
                key: index,
                attrs: { label: item.name, value: item.id }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "200px" },
              attrs: {
                filterable: "",
                clearable: "",
                placeholder: "请选择配网方式"
              },
              model: {
                value: _vm.searchData.netMethod,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "netMethod", $$v)
                },
                expression: "searchData.netMethod"
              }
            },
            [
              _c("el-option", { attrs: { label: "wifi", value: "wifi" } }),
              _vm._v(" "),
              _c("el-option", {
                attrs: { label: "bluetooth", value: "bluetooth" }
              }),
              _vm._v(" "),
              _c("el-option", {
                attrs: { label: "wifi&bluetooth", value: "wifibluetooth" }
              }),
              _vm._v(" "),
              _c("el-option", {
                attrs: { label: "espbluetooth", value: "espbluetooth" }
              }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "扫码绑定", value: "qrcode" } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "200px" },
              attrs: {
                filterable: "",
                clearable: "",
                placeholder: "请选择操作方式"
              },
              model: {
                value: _vm.searchData.controlType,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "controlType", $$v)
                },
                expression: "searchData.controlType"
              }
            },
            [
              _c("el-option", { attrs: { label: "h5", value: "h5" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "app", value: "app" } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.searchFun }
            },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "warning", icon: "el-icon-refresh" },
              on: { click: _vm.resetFun }
            },
            [_vm._v("重置")]
          ),
          _vm._v(" "),
          _vm.checkPermission(["device:deviceType:add"])
            ? _c(
                "el-button",
                {
                  staticClass: "filter-item",
                  attrs: { type: "primary", icon: "el-icon-plus" },
                  on: { click: _vm.addFun }
                },
                [_vm._v("新增")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.newadd,
            width: "500px",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.newadd = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "addForm",
              staticClass: "mark",
              attrs: {
                model: _vm.addData,
                rules: _vm.rules,
                "label-width": "160px"
              }
            },
            [
              _vm.title != "推送设置" && _vm.title != "配网引导"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "品牌名称", prop: "brandId" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.addData.brandId,
                            callback: function($$v) {
                              _vm.$set(_vm.addData, "brandId", $$v)
                            },
                            expression: "addData.brandId"
                          }
                        },
                        _vm._l(_vm.droplist, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title != "推送设置" && _vm.title != "配网引导"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "品类名称", prop: "categoryId" } },
                    [
                      _c("Category", {
                        ref: "mechanRef",
                        attrs: {
                          id: "mechanRef",
                          categoryValue: _vm.addData.categoryId
                        },
                        on: { relCategory: _vm.changeCategory }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title != "推送设置" && _vm.title != "配网引导"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "营销型号", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "20" },
                        on: { input: _vm.onNameInput },
                        model: {
                          value: _vm.addData.name,
                          callback: function($$v) {
                            _vm.$set(_vm.addData, "name", $$v)
                          },
                          expression: "addData.name"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title != "推送设置" && _vm.title != "配网引导"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "工厂型号", prop: "code" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "20" },
                        on: { input: _vm.onCodeInput },
                        model: {
                          value: _vm.addData.code,
                          callback: function($$v) {
                            _vm.$set(_vm.addData, "code", $$v)
                          },
                          expression: "addData.code"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title != "推送设置" && _vm.title != "配网引导"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "服务区域",
                        prop: "regionalDeviceMappers"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            multiple: "",
                            clearable: "",
                            placeholder: "请选择服务区域"
                          },
                          model: {
                            value: _vm.addData.regionalDeviceMappers,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.addData,
                                "regionalDeviceMappers",
                                $$v
                              )
                            },
                            expression: "addData.regionalDeviceMappers"
                          }
                        },
                        _vm._l(_vm.regionList, function(item, index) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.regionalName, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title != "推送设置" && _vm.title != "配网引导"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "机构名称", prop: "insId" } },
                    [
                      _c("Mechanism", {
                        ref: "mechanRef",
                        attrs: {
                          id: "mechanRef",
                          mechanismValue: _vm.addData.insId
                        },
                        on: { relMechanism: _vm.changeMechanism }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title != "推送配置" && _vm.title != "配网引导"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "国家地区", prop: "country" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            multiple: "",
                            clearable: "",
                            placeholder: "请选择国家地区"
                          },
                          model: {
                            value: _vm.addData.country,
                            callback: function($$v) {
                              _vm.$set(_vm.addData, "country", $$v)
                            },
                            expression: "addData.country"
                          }
                        },
                        _vm._l(_vm.countryList, function(item, index) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title != "推送设置" && _vm.title != "配网引导"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "上传图片", prop: "imageFile" } },
                    [
                      _c("input", {
                        attrs: { type: "file", accept: "image/*" },
                        on: { change: _vm.onfileChange }
                      })
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title != "推送设置" && _vm.title != "配网引导"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "图片", id: "file-img" } },
                    [
                      _c("img", {
                        attrs: { src: _vm.addData.imageFile, alt: "" }
                      })
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "配网引导"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "配网方式", prop: "netMethod" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.addData.netMethod,
                            callback: function($$v) {
                              _vm.$set(_vm.addData, "netMethod", $$v)
                            },
                            expression: "addData.netMethod"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "wifi", value: "wifi" }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "bluetooth", value: "bluetooth" }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: {
                              label: "wifibluetooth",
                              value: "wifibluetooth"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: {
                              label: "espbluetooth",
                              value: "espbluetooth"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "扫码绑定", value: "qrcode" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              (_vm.addData.netMethod == "wifi" ||
                _vm.addData.netMethod == "wifibluetooth") &&
              _vm.title == "配网引导"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "wifi名", prop: "wifiRules" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "20" },
                        model: {
                          value: _vm.addData.wifiRules,
                          callback: function($$v) {
                            _vm.$set(_vm.addData, "wifiRules", $$v)
                          },
                          expression: "addData.wifiRules"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.addData.netMethod == "bluetooth" ||
              (_vm.addData.netMethod == "wifibluetooth" &&
                _vm.title == "配网引导")
                ? _c(
                    "el-form-item",
                    { attrs: { label: "蓝牙名", prop: "bluetoothRules" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "20" },
                        model: {
                          value: _vm.addData.bluetoothRules,
                          callback: function($$v) {
                            _vm.$set(_vm.addData, "bluetoothRules", $$v)
                          },
                          expression: "addData.bluetoothRules"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "配网引导"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "操作方式", prop: "controlType" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.addData.controlType,
                            callback: function($$v) {
                              _vm.$set(_vm.addData, "controlType", $$v)
                            },
                            expression: "addData.controlType"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "h5", value: "h5" }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "app", value: "app" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.addData.controlType == "h5" && _vm.title == "配网引导"
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "500px" },
                      attrs: { label: "H5地址", prop: "h5Path" }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "197.5px" },
                            attrs: { maxlength: "128" },
                            model: {
                              value: _vm.addData.h5Path,
                              callback: function($$v) {
                                _vm.$set(_vm.addData, "h5Path", $$v)
                              },
                              expression: "addData.h5Path"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to:
                                  "/configure/h5Version/" +
                                  _vm.addData.id +
                                  "/" +
                                  _vm.addData.name +
                                  "/" +
                                  _vm.addData.code
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  attrs: { size: "mini", type: "primary" }
                                },
                                [_vm._v("H5版本配置")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.addData.controlType == "h5" && _vm.title == "配网引导"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "pad/phone", prop: "h5Type" } },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          on: { change: _vm.h5TypeChange },
                          model: {
                            value: _vm.checkList,
                            callback: function($$v) {
                              _vm.checkList = $$v
                            },
                            expression: "checkList"
                          }
                        },
                        [
                          _c("el-checkbox", { attrs: { label: "pad" } }),
                          _vm._v(" "),
                          _c("el-checkbox", { attrs: { label: "phone" } })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "配网引导"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "配网说明", prop: "netTips" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea", rows: 5, maxlength: "200" },
                        model: {
                          value: _vm.addData.netTips,
                          callback: function($$v) {
                            _vm.$set(_vm.addData, "netTips", $$v)
                          },
                          expression: "addData.netTips"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "配网引导"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "引导图片", prop: "netImg" } },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "upload-demo",
                          attrs: {
                            action: "string",
                            accept: ".png,.jpg",
                            "http-request": _vm.uploadIcon,
                            "on-success": _vm.onsuccessNotIcon,
                            "show-file-list": false
                          }
                        },
                        [
                          _c(
                            "el-button",
                            { attrs: { size: "small", type: "primary" } },
                            [_vm._v("上传图标")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "upload-img",
                        attrs: { src: _vm.addData.netImg, alt: "", width: "50" }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "配网引导"
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "isblock",
                      attrs: { label: "是否支持音箱" }
                    },
                    [
                      _c("el-checkbox", {
                        attrs: { "false-label": 0, "true-label": 1 },
                        model: {
                          value: _vm.addData.soundboxSupport,
                          callback: function($$v) {
                            _vm.$set(_vm.addData, "soundboxSupport", $$v)
                          },
                          expression: "addData.soundboxSupport"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "配网引导"
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "isblock",
                      attrs: { label: "不支持主动查询" }
                    },
                    [
                      _c("el-checkbox", {
                        attrs: { "false-label": 0, "true-label": 1 },
                        model: {
                          value: _vm.addData.runningCheckUnabled,
                          callback: function($$v) {
                            _vm.$set(_vm.addData, "runningCheckUnabled", $$v)
                          },
                          expression: "addData.runningCheckUnabled"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "推送设置"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "MQTT推送", prop: "mqtt" } },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 0 },
                          model: {
                            value: _vm.addData.mqtt,
                            callback: function($$v) {
                              _vm.$set(_vm.addData, "mqtt", $$v)
                            },
                            expression: "addData.mqtt"
                          }
                        },
                        [_vm._v("否")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 1 },
                          model: {
                            value: _vm.addData.mqtt,
                            callback: function($$v) {
                              _vm.$set(_vm.addData, "mqtt", $$v)
                            },
                            expression: "addData.mqtt"
                          }
                        },
                        [_vm._v("是")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "推送设置"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "kafka推送", prop: "kafka" } },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 0 },
                          model: {
                            value: _vm.addData.kafka,
                            callback: function($$v) {
                              _vm.$set(_vm.addData, "kafka", $$v)
                            },
                            expression: "addData.kafka"
                          }
                        },
                        [_vm._v("否")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 1 },
                          model: {
                            value: _vm.addData.kafka,
                            callback: function($$v) {
                              _vm.$set(_vm.addData, "kafka", $$v)
                            },
                            expression: "addData.kafka"
                          }
                        },
                        [_vm._v("是")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "推送设置" && _vm.addData.kafka == "1"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "kafka主题", prop: "kafkaTopic" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.addData.kafkaTopic,
                            callback: function($$v) {
                              _vm.$set(_vm.addData, "kafkaTopic", $$v)
                            },
                            expression: "addData.kafkaTopic"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: "family_topic",
                              value: "family_topic"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: {
                              label: "ws_push_new",
                              value: "ws_push_new"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "新增"
                ? _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSubmit }
                        },
                        [_vm._v("提交")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.onCencal } }, [
                        _vm._v("取消")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "修改"
                ? _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onUpdate }
                        },
                        [_vm._v("提交")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.onCencal } }, [
                        _vm._v("取消")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "配网引导"
                ? _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onNetwork }
                        },
                        [_vm._v("提交")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.onCencal } }, [
                        _vm._v("取消")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "推送设置"
                ? _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.pushBtn }
                        },
                        [_vm._v("推送")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.onCencal } }, [
                        _vm._v("取消")
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { attrs: { id: "dialog2" } }, [
        _c(
          "div",
          { attrs: { id: "dia_box" } },
          [
            _c("div", { attrs: { id: "qrcode" } }),
            _vm._v(" "),
            _c("el-button", { on: { click: _vm.onCencal2 } }, [_vm._v("关闭")]),
            _vm._v(" "),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.downloadQrcode } },
              [_vm._v("下载")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", width: "45", label: "序号" }
          }),
          _vm._v(" "),
          _c("el-table-column", { attrs: { prop: "name", label: "营销型号" } }),
          _vm._v(" "),
          _c("el-table-column", { attrs: { prop: "code", label: "工厂型号" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "servicesRegionalList", label: "服务区域" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(_vm.regionalName(scope.row)))])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "brandName", label: "品牌名称" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "categoryName", label: "品类名称" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "operatorName", label: "维护人" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "insName", label: "组织名称" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "imgUrl", label: "图片" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("img", {
                      staticClass: "upload-img",
                      attrs: { src: scope.row.imgUrl, alt: "" }
                    })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "country", label: "国家地区" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(_vm.countryName(scope.row)))])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "netMethod", label: "配网方式" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "controlType", label: "操作方式" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { width: "155", label: "创建时间" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("dateFilter")(scope.row.createTime)))
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { width: "230", label: "操作", prop: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.checkPermission(["device:deviceType:updata"])
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              title: "修改",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.updateMenu(scope.row)
                              }
                            }
                          },
                          [_vm._v("修改")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "warning",
                          title: "二维码",
                          size: "mini"
                        },
                        on: {
                          click: function($event) {
                            return _vm.lookView(scope.row)
                          }
                        }
                      },
                      [_vm._v("二维码")]
                    ),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _vm.checkPermission(["device:deviceType:del"])
                      ? _c(
                          "el-button",
                          {
                            staticClass: "mt10",
                            attrs: {
                              type: "danger",
                              title: "删除",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.delMenu(scope.row)
                              }
                            }
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "mt10",
                        attrs: {
                          type: "info",
                          title: "推送设置",
                          size: "mini"
                        },
                        on: {
                          click: function($event) {
                            return _vm.pushFun(scope.row)
                          }
                        }
                      },
                      [_vm._v("推送设置")]
                    ),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _vm.checkPermission(["device:deviceType:network"])
                      ? _c(
                          "el-button",
                          {
                            staticClass: "mt10",
                            attrs: {
                              type: "primary",
                              title: "配网引导",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.networkMenu(scope.row)
                              }
                            }
                          },
                          [_vm._v("配网引导")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.checkPermission(["device:deviceType:specialRec"])
                      ? _c(
                          "router-link",
                          {
                            attrs: {
                              to: "/configure/specialRecommend/" + scope.row.id
                            }
                          },
                          [
                            _c(
                              "el-button",
                              { attrs: { type: "success", size: "mini" } },
                              [_vm._v("特殊推荐")]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "mt10",
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.checkProductKey(scope.row)
                          }
                        }
                      },
                      [_vm._v("产品密钥")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageData.total > 0,
                expression: "pageData.total>0"
              }
            ],
            attrs: {
              "current-page": _vm.pageData.page,
              "page-sizes": [10, 20, 30, 40, 50, 100, 200, 300, 400, 500],
              "page-size": _vm.pageData.rows,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pageData.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showProduct,
            title: "产品密钥",
            center: "",
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              _vm.showProduct = $event
            },
            close: function($event) {
              _vm.showProduct = false
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: "20" } }, [
                _c("div", { staticStyle: { "line-height": "35px" } }, [
                  _vm._v(
                    "ProductSecret：" + _vm._s(_vm.productInfo.productSecret)
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: "4" } },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "clipboard",
                          rawName: "v-clipboard:success",
                          value: _vm.onProductCopySuccess,
                          expression: "onProductCopySuccess",
                          arg: "success"
                        },
                        {
                          name: "clipboard",
                          rawName: "v-clipboard:copy",
                          value: _vm.productInfo.productSecret,
                          expression: "productInfo.productSecret",
                          arg: "copy"
                        }
                      ],
                      attrs: { type: "text" }
                    },
                    [_vm._v("复制")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: "20" } }, [
                _c("div", { staticStyle: { "line-height": "35px" } }, [
                  _vm._v("ProductKey：" + _vm._s(_vm.productInfo.productKey))
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: "4" } },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "clipboard",
                          rawName: "v-clipboard:success",
                          value: _vm.onProductCopySuccess,
                          expression: "onProductCopySuccess",
                          arg: "success"
                        },
                        {
                          name: "clipboard",
                          rawName: "v-clipboard:copy",
                          value: _vm.productInfo.productKey,
                          expression: "productInfo.productKey",
                          arg: "copy"
                        }
                      ],
                      attrs: { type: "text" }
                    },
                    [_vm._v("复制")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { slot: "footer", type: "danger" },
              on: {
                click: function($event) {
                  _vm.showProduct = false
                }
              },
              slot: "footer"
            },
            [_vm._v("关闭")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }